import { ReactNode } from "react";
import { create } from "zustand";

type TLayoutStore = {
  accessDenied: boolean;
  isDataNotFound: boolean;
  showBaseLayout: boolean;
  showDimBackground: boolean;
  pageAction: ReactNode;
  showProgress: boolean;
  onShowBaseLayout: (showBaseLayout: boolean) => void;
  onShowDimBackground: (showDimBackground: boolean) => void;
  onSetPageAction: (pageAction: ReactNode) => void;
  onResetPageAction: () => void;
  onShowProgress: (showProgress: boolean) => void;
  onSetAccessDenied: (accessDenied: boolean) => void;
  onSetIsDataNotFound: (dataNotFound: boolean) => void;
};

export const useLayoutStore = create<TLayoutStore>((set) => ({
  isDataNotFound: false,
  accessDenied: false,
  showBaseLayout: true,
  showDimBackground: false,
  pageAction: null,
  showProgress: false,
  breadcrumbItems: [],
  onShowBaseLayout: (showBaseLayout) => {
    set({ showBaseLayout });
  },
  onShowDimBackground: (showDimBackground) => {
    set({ showDimBackground });
  },
  onSetPageAction: (pageAction) => {
    set({ pageAction });
  },
  onResetPageAction: () => {
    set({ pageAction: null });
  },
  onShowProgress: (showProgress) => {
    set({ showProgress });
  },
  onSetAccessDenied: (accessDenied) => {
    set({ accessDenied });
  },
  onSetIsDataNotFound: (isDataNotFound) => {
    set({ isDataNotFound });
  },
}));
